import React from 'react'
import BomLibrary from '../configuration/bomLibrary/BomLibrary'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

// S1 (HU-01, historia 117): route shell of the BOM library, same pattern as MainRawMaterialReference.
const MainBomLibrary = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('BOM library'),
      component: <BomLibrary />
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainBomLibrary
